/**
 * Auth Bridge — decouples the axios interceptor from React's component tree.
 *
 * Navigation ref is set by a component inside the Router (AppRoutes),
 * session-expired events are emitted by api.js and consumed by AuthContext + NewTravelRequest,
 * and shared refresh state prevents the proactive timer and 401 interceptor from racing.
 */

// Navigation ref — set by AppRoutes (inside Router), called by api.js interceptor
let navigateRef = null;
export const setNavigate = (fn) => { navigateRef = fn; };
export const getNavigate = () => navigateRef;

// Session-expired event — emitted by api.js, consumed by AuthContext + NewTravelRequest
const listeners = [];
export const onSessionExpired = (cb) => {
  listeners.push(cb);
  return () => {
    const idx = listeners.indexOf(cb);
    if (idx !== -1) listeners.splice(idx, 1);
  };
};
export const emitSessionExpired = (reason) => {
  listeners.forEach(cb => cb(reason));
};

// Shared refresh state — prevents proactive refresh and 401 interceptor from racing
let _refreshInProgress = false;
export const getRefreshInProgress = () => _refreshInProgress;
export const setRefreshInProgress = (val) => { _refreshInProgress = val; };
